import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { Checkbox } from "@circle-react-uikit/Form/Checkbox";

interface RowProps {
  date: string;
  id: string;
  name: string;
  onChange: (event: { name: string; value: boolean }) => void;
  time: string;
  value: boolean;
}

export const Row = ({ id, name, date, time, value, onChange }: RowProps) => (
  <li>
    <label className="m-0 flex items-center justify-between pr-1" htmlFor={id}>
      <div className="leading-none">
        <div>
          <Typography.LabelSm weight="semibold">{date}</Typography.LabelSm>
        </div>
        <div className="text-secondary">
          <Typography.LabelXs>{time}</Typography.LabelXs>
        </div>
      </div>
      <Checkbox
        id={id}
        name={name}
        isFormItem={false}
        checked={value}
        onChange={e => onChange({ name, value: e.target.checked })}
        /* TODO Review props */
        option={{
          value: "",
          label: "",
        }}
      />
    </label>
  </li>
);
